import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { interval, Subscription } from 'rxjs';

@Component({
  selector: "app-information-dialog",
  templateUrl: "./new-version-dialog.component.html",
  styleUrls: ["./new-version-dialog.component.scss"]
})
export class NewVersionDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NewVersionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
  reloading: boolean = false;


  ngOnInit() {

  }



  closeAction() {
    this.reloading = true;
    window.location.href = "/"
  }
}
